<div  class="bg-white p-3 shadow-3 border-round-sm">


   <div class="rem-text-default flex align-items-center">
          <div class="rem-bg-light p-2 mr-2">
            <i class="pi pi-envelope font-medium"></i>
          </div>
          <div class="text-lg">Communications</div>
        </div>
        <div class="mt-5">

          <div class="mt-3 px-3 flex align-items-center gap-3 mb-8">
            <p-floatLabel>
            <p-multiSelect
              [style]="{width: '200px'}"
              id="creditorsCommunications"
              [options]="creditors"
              [(ngModel)]="selectedCreditors"
              (ngModelChange)="onChangeCreditors($event)"
              optionLabel="label"          
              filterBy="value,label">
              <ng-template let-creditor pTemplate="item">
                <div class="flex align-items-center justify-content-between flex-1">
                  <div>{{ creditor.label }}</div>
                  <div class="ml-2">{{ creditor.value }}</div>
                </div>
              </ng-template>
            </p-multiSelect>
            <label for="creditorsCommunications">Select Clients</label>
            </p-floatLabel>
            
            <p-floatLabel>
              <p-calendar 
                    id="fromDateCommunications"
                    [(ngModel)]="fromDate"
                    [readonlyInput]="true"      
                    [maxDate]="toDate"             
              />
              <label for="fromDateCommunications">From Date</label>
            </p-floatLabel>

            <p-floatLabel>
              <p-calendar 
                    id="toDateCommunications"
                    [(ngModel)]="toDate"
                    [readonlyInput]="true"            
                    [minDate]="fromDate"
                    [maxDate]="todaysDate"
              />
              <label for="toDateCommunications">To Date</label>
            </p-floatLabel>

            <p-floatLabel>
                <p-multiSelect
                  [style]="{width: '200px'}"
                  id="notificationTypesCommunications"
                  [options]="notificationTypes"
                  [(ngModel)]="selectedNotificationTypes"
                  (ngModelChange)="onChangeNotificationTypes($event)"
                  optionLabel="label"
                  optionValue="value" 
                  />
                <label for="notificationTypesCommunications">Notification Type</label>
            </p-floatLabel>

            <p-floatLabel>
                <p-dropdown 
                    [showClear]="true"
                      id="timezonesCommunications" 
                      [options]="timezones"
                      [(ngModel)]="selectedTimezone"
                      optionLabel="label" 
                      optionValue="value" 
                    />
                <label for="timezonesCommunications">Timezone</label>
            </p-floatLabel>
    
            <remitter-button
              label='Generate'
              icon='send'
              (click)="getGraphCommunications()"
            >     
            </remitter-button>
          </div>

          <div class="chart-communications-div pt-5">
            <div class="font-bold text-700 text-lg">Messages Sent by Creditor</div>
            <div *ngIf="isArrayWithData(chartOptionsBar)">
              <div 
                *ngFor="let chart of chartOptionsBar; let i = index" 
                [ngStyle]="{  minHeight: chart['dataLength'] === 10? 'auto' : getGraphHeight(chart['dataLength']) }"
                echarts 
                [options]="chart" 
                class="echart">
              </div>
            </div>
             <div *ngIf="!isArrayWithData(chartOptionsBar)" class="flex align-items-center justify-content-center h-20rem">
               <div class="font-bold text-red-700">There is no data to display. Please adjust your filter.</div>
             </div>
          </div>


          <div class="mt-5 ">
                <div class="font-bold text-700 text-lg">Share of Messages Sent by Creditor</div>
                <div *ngIf="isArrayWithData(chartOptionsBar)">
                   <div echarts [options]="chartOptionsDonut"></div>
                </div>

                <div *ngIf="!isArrayWithData(chartOptionsBar)" class="flex align-items-center justify-content-center h-20rem">
                    <div class="font-bold text-red-700">There is no data to display. Please adjust your filter.</div>
                </div>
          </div>


        </div>

        <div class="mt-4 flex align-items-center gap-3 px-3">
          <div class="flex align-items-center border-1 border-300 border-round-sm p-3 gap-2">
              <div>
                <i class="pi pi-comments text-2xl rem-text-default"></i>
              </div>
              <div>
                <div class="font-bold">Messages Sent</div>
                <div class="text-lg rem-text-default font-bold">{{ (totalMessagesSentCommunications || 0) | number:'1.0-0' }}</div>
              </div>
          </div>

          <div class="flex align-items-center border-1 border-300 border-round-sm p-3 gap-2">
              <div>
                <i class="pi pi-envelope text-2xl rem-text-default"></i>
              </div>
              <div>
                <div class="font-bold">Emails Sent</div>
                <div class="text-lg rem-text-default font-bold">{{ (totalEmailsSentCommunications || 0) | number:'1.0-0' }}</div>
              </div>
          </div>

          <div class="flex align-items-center border-1 border-300 border-round-sm p-3 gap-2">
              <div>
                <i class="pi pi-mobile text-2xl rem-text-default"></i>
              </div>
              <div>
                <div class="font-bold">SMS Sent</div>
                <div class="text-lg rem-text-default font-bold">{{ (totalSmsSentCommunications || 0) | number:'1.0-0' }}</div>
              </div>
          </div>

            <div class="flex align-items-center border-1 border-300 border-round-sm p-3 gap-2">
              <div>
                <i class="pi pi-download text-2xl rem-text-default"></i>
              </div>
              <div>
                <div class="font-bold">VM Drops Sent</div>
                <div class="text-lg rem-text-default font-bold">{{ (totalVmDropsSentCommunications || 0) | number:'1.0-0' }}</div>
              </div>
          </div>

        </div>
</div>>
